var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#767B85",
    d: "M16 5.813c0-.233-.18-.378-.539-.435l-4.826-.69L8.47.388C8.35.128 8.192 0 8.001 0c-.193 0-.35.13-.472.387L5.365 4.688l-4.827.69C.18 5.435 0 5.58 0 5.813c0 .132.08.283.24.454l3.5 3.345-.826 4.726a1.51 1.51 0 0 0-.02.19.55.55 0 0 0 .101.335c.068.091.168.137.303.137a.826.826 0 0 0 .385-.113L8 12.656l4.317 2.23a.788.788 0 0 0 .385.114c.263 0 .394-.157.394-.472 0-.082-.003-.145-.01-.19l-.826-4.725 3.49-3.346c.167-.164.25-.316.25-.454zm-5.067 3.374.692 3.98L8 11.284l-3.635 1.881.702-3.979L2.125 6.38l4.058-.586L8 2.184l1.817 3.61 4.058.586-2.942 2.807z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarMenu);
export default __webpack_public_path__ + "static/media/star-menu.92a04ce0e065675512f2b0e005eb674f.svg";
export { ForwardRef as ReactComponent };